import {
  ForbiddenError,
  useFilmFeaturePlaylistQuery,
  useFilmRecommendedQuery,
} from '@mwxltd/flix-api-client'
import { useFetchBannerAdDecision } from '@flix/common/domain/ads/useFetchBannerAdDecision'
import LoadingGrid from '../../../components/layout/Loading/LoadingGrid'
import VideoPlayer from '../../../components/video/VideoPlayer/VideoPlayer'
import { ForbiddenErrorPage } from '../../error/ForbiddenErrorPage'
import { onFilmPlayerClose } from '../onFilmPlayerClose'

const FeaturePlayerPage = ({ filmSlug, history, location }) => {
  const {
    loading,
    error,
    data: { film, playlist = [] },
    refreshUrl,
  } = useFilmFeaturePlaylistQuery({ slug: filmSlug })

  const { data: nextRecommendation } = useFilmRecommendedQuery(
    { filmId: film?.id, limit: 1 },
    { skip: !film },
  )

  const fetchBannerAdDecision = useFetchBannerAdDecision()

  if (error instanceof ForbiddenError) {
    return <ForbiddenErrorPage onBack={onFilmPlayerClose(filmSlug, history, location)} />
  }

  if (loading) return <LoadingGrid />

  return (
    <VideoPlayer
      playlist={playlist}
      onRequestRefreshUrl={refreshUrl}
      onRequestClose={onFilmPlayerClose(filmSlug, history, location)}
      errorMetadata={{ film: { slug: filmSlug } }}
      filmSlug={filmSlug}
      filmId={film?.id}
      contentType={film?.type}
      nextRecommendation={nextRecommendation?.filmRecommendedList.items[0]}
      fetchBannerAdDecision={fetchBannerAdDecision}
    />
  )
}

export default FeaturePlayerPage
